import Vue from 'vue'
import Router, { Route } from 'vue-router'
import {
  addressGuard, addressSearchMultisiteGuard, cockpitGuard, commissionsGuard,
  dashboardGuard, dispositionGuard,
  isUserLoggedInGuard,
  loginPageGuard,
  masterDataGuard, printingActivityGuard, productGuard, projectGuard, recruitingGuard,
  rootPageGuard,
  settingsGuard, toolsGuard, ticketingGuard
} from './guards'
import LoginPage from '@/pages/LoginPage.vue'
import DashboardPage from '@/pages/DashboardPage.vue'
import EmployeeDetailPage from '@/pages/EmployeeDetailPage.vue'
import ProfilePage from '@/pages/ProfilePage.vue'
import QcqPage from '@/pages/QcqPage.vue'
import QcqQualificationPage from '@/pages/QcqQualificationPage.vue'
import QcqCompetencePage from '@/pages/QcqCompetencePage.vue'
import QcqQualityPage from '@/pages/QcqQualityPage.vue'
import PlanningPage from '@/pages/PlanningPage.vue'
import MasterDataWorkPage from '@/pages/MasterDataWorkPage.vue'
import MasterDataShiftsPage from '@/pages/MasterDataShiftsPage.vue'
import MasterDataSimpleTimeModelPage from '@/pages/MasterDataSimpleTimeModelPage.vue'
import MasterDataIndustrialTimeModelPage from '@/pages/MasterDataIndustrialTimeModelPage.vue'
import PlanningGroupsPage from '@/pages/PlanningGroupsPage.vue'
import CompanySettingsPage from "@/pages/CompanySettingsPage.vue";
import CalendarEventPage from "@/pages/CalendarEventPage.vue";
import ReportingPage from "@/pages/ReportingPage.vue";
import VersionPage from "@/pages/VersionPage.vue";
import AbsencesPage from '@/pages/AbsencesPage.vue'
import EmployeeHierarchyPage from '@/pages/EmployeeHierarchyPage.vue'
import DashboardSettingsPage from '@/pages/DashboardSettingsPage.vue'
import EmailSmtpSettingsPage from '@/pages/settings/EmailSmtpSettingsPage.vue'
import EmailDefaultTextPage from '@/pages/settings/EmailDefaultTextPage.vue'
import ReAllocation from '@/components/disposition/ReAllocation.vue'
import Allocation from '@/components/disposition/Allocation.vue'
import SubstitutionPage from '@/components/disposition/SubstitutionPage.vue'
import ProjectPage from '@/pages/ProjectPage.vue'
import AddressSearchPage from '@/pages/AddressSearchPage.vue'
import ToolsPage from '@/pages/ToolsPage.vue'
import ProductSearchPage from '@/pages/ProductSearchPage.vue'
import SecurityPage from '@/pages/settings/SecurityPage.vue'
import EmployeeSecurityPage from '@/pages/settings/EmployeeSecurityPage.vue'
import ProfitCenterAdditionalFieldsPage from '@/pages/settings/ProfitCenterAdditionalFieldsPage.vue'
import ConfigurationPage from '@/pages/settings/ConfigurationPage.vue'
import AddressSearchMultisitePage from '@/pages/AddressSearchMultisitePage.vue'
import PrintingActivityPage from '@/pages/PrintingActivityPage.vue'
import CockpitPage from '@/pages/CockpitPage.vue'
import RecruitingPage from '@/pages/RecruitingPage.vue'
import CommissionsSearchPage from '@/pages/CommissionsSearchPage.vue'
import TicketingSearchPage from '@/pages/TicketingSearchPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      name: 'home',
      beforeEnter: rootPageGuard
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      beforeEnter: loginPageGuard
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardPage,
      beforeEnter: dashboardGuard
    },
    {
      path: '/employee-detail/:departmentId?/:employeeId?',
      name: '/EmployeeDetail',
      component: EmployeeDetailPage,
      props: (route: Route) => ({
        departmentId: parseInt(route.params.departmentId, 10),
        employeeId: parseInt(route.params.employeeId, 10),
      }),
      beforeEnter: masterDataGuard
    },
    {
      path: '/profile',
      name: 'profile',
      component: ProfilePage,
      beforeEnter: isUserLoggedInGuard
    },
    {
      path: '/simple-time-model',
      name: 'simple-time-model',
      component: MasterDataSimpleTimeModelPage,
      beforeEnter: masterDataGuard
    },
    {
      path: '/industrial-time-model',
      name: 'industrial-time-model',
      component: MasterDataIndustrialTimeModelPage,
      beforeEnter: isUserLoggedInGuard
    },
    {
      path: '/qcq',
      name: 'qcq',
      component: QcqPage,
      beforeEnter: masterDataGuard,
      children: [
        {
          path: '/qcq/qualification',
          name: 'QCQ/Qualification',
          component: QcqQualificationPage,
          props: true
        },
        {
          path: '/qcq/competence',
          name: 'QCQ/Competence',
          component: QcqCompetencePage,
          props: true
        },
        {
          path: '/qcq/quality',
          name: 'QCQ/Quality',
          component: QcqQualityPage,
          props: true
        }
      ]
    },
    {
      path: '/work',
      name: 'Work',
      component: MasterDataWorkPage,
      beforeEnter: masterDataGuard
    },
    {
      path: '/shifts',
      name: 'MasterData/Shifts',
      component: MasterDataShiftsPage,
      beforeEnter: masterDataGuard
    },
    {
      path: '/absences',
      name: 'absences',
      component: AbsencesPage,
      beforeEnter: isUserLoggedInGuard
    },
    {
      path: '/planning',
      name: 'planning',
      component: PlanningPage,
      beforeEnter: isUserLoggedInGuard
    },
    {
      path: '/reporting',
      name: 'reporting',
      component: ReportingPage,
      beforeEnter: isUserLoggedInGuard
    },
    {
      path: '/tools/:code?',
      name: 'Tools',
      component: ToolsPage,
      props: (route: Route) => ({
        code: route.params.code
      }),
      beforeEnter: toolsGuard
    },
    {
      path: '/settings/configuration/:groupId?/:subGroupId?',
      name: 'Configuration',
      component: ConfigurationPage,
      props: (route: Route) => ({
        groupId: parseInt(route.params.groupId, 10),
        subGroupId: parseInt(route.params.subGroupId, 10)
      }),
      beforeEnter: settingsGuard
    },
    {
      path: '/settings/company-settings',
      name: 'Company Settings',
      component: CompanySettingsPage,
      beforeEnter: settingsGuard
    },
    {
      path: '/settings/calendar-event-settings/:profitCenterId',
      name: '/settings/calendar-event-settings',
      component: CalendarEventPage,
      props: (route: Route) => ({
        profitCenterId: parseInt(route.params.profitCenterId, 10)
      }),
      beforeEnter: settingsGuard
    },
    {
      path: '/settings/planning-groups-settings/:departmentId',
      name: '/settings/planning-groups-settings',
      component: PlanningGroupsPage,
      props: (route: Route) => ({
        //profitCenterId: parseInt(route.params.profitCenterId, 10),
        departmentId: parseInt(route.params.departmentId, 10)
      }),
      beforeEnter: settingsGuard
    },
    {
      path: '/settings/employee-hierarchy/:departmentId',
      name: 'Employee Hierarchy',
      component: EmployeeHierarchyPage,
      props: (route: Route) => ({
        departmentId: parseInt(route.params.departmentId, 10)
      }),
      beforeEnter: settingsGuard
    },
    {
      path: '/settings/profit-center-additional-fields/:profitCenterId',
      name: '/settings/profit-center-additional-fields',
      component: ProfitCenterAdditionalFieldsPage,
      props: (route: Route) => ({
        profitCenterId: parseInt(route.params.profitCenterId, 10)
      }),
      beforeEnter: settingsGuard
    },
    {
      path: '/settings/email-smtp-settings',
      name: 'EmailSmtpSettings',
      component: EmailSmtpSettingsPage,
      beforeEnter: settingsGuard
    },
    {
      path: '/settings/email-default-text',
      name: 'EmailDefaultText',
      component: EmailDefaultTextPage,
      beforeEnter: settingsGuard
    },
    {
      path: '/settings/registered-employees',
      name: 'RegisteredEmployees',
      component: SecurityPage,
      beforeEnter: settingsGuard
    },
    {
      path: '/settings/employee-security',
      name: 'EmployeeSecurity',
      component: EmployeeSecurityPage,
      beforeEnter: settingsGuard
    },
    {
      path: '/version',
      name: '/version',
      component: VersionPage
    },
    {
      path: '/dashboard-settings',
      name: 'Dashboard Settings',
      component: DashboardSettingsPage,
      beforeEnter: dashboardGuard
    },
    {
      path: '/address-search-multisite',
      name: 'AddressSearchMultisite',
      component: AddressSearchMultisitePage,
      beforeEnter: addressSearchMultisiteGuard
    },
    {
      path: '/address/:addressGroupId?',
      name: 'AddressSearch',
      component: AddressSearchPage,
      props: (route: Route) => ({
        addressGroupId: parseInt(route.params.addressGroupId, 10)
      }),
      beforeEnter: addressGuard
    },
    {
      path: '/commissions/:commissionGroupId?',
      name: 'CommissionsSearch',
      component: CommissionsSearchPage,
      props: (route: Route) => ({
        commissionGroupId: route.params.commissionGroupId
      }),
      beforeEnter: commissionsGuard
    },
    {
      path: '/product/:productGroupId?',
      name: 'ProductSearch',
      component: ProductSearchPage,
      props: (route: Route) => ({
        productGroupId: parseInt(route.params.productGroupId, 10)
      }),
      beforeEnter: productGuard
    },
    {
      path: '/project/:projectCode?/:projectBez?',
      name: 'Project',
      component: ProjectPage,
      props: (route: Route) => ({
        projectCode: route.params.projectCode,
        projectBez: route.params.projectBez
      }),
      beforeEnter: projectGuard
    },
    {
      path: '/disposition/allocation',
      name: 'Disposition',
      component: Allocation,
      beforeEnter: dispositionGuard
    },
    {
      path: '/disposition/substitution',
      name: 'Disposition',
      component: SubstitutionPage,
      beforeEnter: dispositionGuard
    },
    {
      path: '/disposition/re-allocation',
      name: 'Disposition',
      component: ReAllocation,
      beforeEnter: dispositionGuard
    },
    {
      path: '/printing-activity',
      name: 'PrintingActivity',
      component: PrintingActivityPage,
      beforeEnter: printingActivityGuard
    },
    {
      path: '/cockpit',
      name: 'Cockpit',
      component: CockpitPage,
      beforeEnter: cockpitGuard
    },
    {
      path: '/recruiting/:recruitingGroupId/:search?',
      name: 'Recruiting',
      component: RecruitingPage,
      props: (route: Route) => ({
        recruitingGroupId: parseInt(route.params.recruitingGroupId, 10),
        search: route.params.search
      }),
      beforeEnter: recruitingGuard
    },
    {
      path: '/ticketing/:ticketingGroupId?',
      name: 'Ticketing',
      component: TicketingSearchPage,
      props: (route: Route) => ({
        ticketingGroupId: parseInt(route.params.ticketingGroupId, 10)
      }),
      beforeEnter: ticketingGuard
    }
  ]
})
